/* unplugin-vue-components disabled */import script from "./detailsStatus.vue?vue&type=script&lang=js"
export * from "./detailsStatus.vue?vue&type=script&lang=js"

import "./detailsStatus.vue?vue&type=style&index=0&id=8a9a7216&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8a9a7216"]])

export default __exports__